function getParties(parties) {
  let list = '';
  parties.forEach((element) => {
    list += `
      <tr class="c-info-map-table__row c-info-map-table__row--info">
        <td class="c-info-map-table__party ${element.partyCode}">
          ${element.partyName}
        </td>
        <td class="c-info-map-table__percentage">
          &nbsp; ${element.votesPct.toFixed(2).replaceAll(".", ",")}%
        </td>
      </tr>
    `;
  });

  return list;
}


function hideMapInfo() {
  document.querySelector('.js-map-info').innerHTML = '';
  document.querySelector('.js-map-info-default').classList.remove('hide');
  document.querySelector('.js-map-info').classList.remove('is-active');
}

function showMapInfo(data) {
  const template = `
    <table class="c-info-map-table">
      <thead class="c-info-map-table__head">
        <tr class="c-info-map-table__row">
          <td>${data.nameProvince}</td>
          <td>
            <span class="c-info-map-table__head-percentage">% Votos</span>
          </td>
        </tr>
      </thead>
      <tbody class="c-info-map-table__tbody">
        ${getParties(data.dataVoting.parties)}
      </tbody>
    </table>
    <div class="c-info-map-table__footer">
      Escrutado
      <p class="c-info-map-table__percentage">
        ${data.dataVoting.voting.votesCountedPct.toFixed(2).replaceAll(".", ",")}%
      </p>
    </div>
  `;

  document.querySelector('.js-map-info').innerHTML = template;
  document.querySelector('.js-map-info-default').classList.add('hide');
  document.querySelector('.js-map-info').classList.add('is-active');
}

export default {
  showMapInfo,
  hideMapInfo,
};
